import { roofTruncationOptionsNew } from "doc/utils/roofTools";

export const DEFAULT_ROOF_TRUNCATION_OPTIONS = roofTruncationOptionsNew();
